import { useState, useEffect } from "react";

import {
  faCaretLeft,
  faCaretRight,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Radium, { StyleRoot } from "radium";
import { fadeInRightBig } from "react-animations";
import Img from "react-image";
import Slider from "react-slick";
import Carousel, { Modal, ModalGateway } from "react-images";
import Media, { useMediaQuery } from "react-responsive";

import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
//un import por imagen
import idilioVistania1 from "./../../assets/images2/realEstate/idilioVistania/FAC1.webp";
import idilioVistania2 from "./../../assets/images2/realEstate/idilioVistania/FAC2.webp";
import idilioVistania3 from "./../../assets/images2/realEstate/idilioVistania/FAC3.webp";
import idilioVistania4 from "./../../assets/images2/realEstate/idilioVistania/LOB1.webp";
import idilioVistania5 from "./../../assets/images2/realEstate/idilioVistania/SAL1.webp";
import idilioVistania6 from "./../../assets/images2/realEstate/idilioVistania/SAL2.webp";
import idilioVistania7 from "./../../assets/images2/realEstate/idilioVistania/SAL3.webp";
import idilioVistania8 from "./../../assets/images2/realEstate/idilioVistania/HAB1.webp";
import idilioVistania9 from "./../../assets/images2/realEstate/idilioVistania/HAB2.webp";
import idilioVistania10 from "./../../assets/images2/realEstate/idilioVistania/HAB3.webp";
import idilioVistania11 from "./../../assets/images2/realEstate/idilioVistania/BAN1.webp";
import idilioVistania12 from "./../../assets/images2/realEstate/idilioVistania/BAN2.webp";
import "./sass/index.sass";

const imagesIdilioVistania = [
  idilioVistania1,
  idilioVistania2,
  idilioVistania3,
  idilioVistania4,
  idilioVistania5,
  idilioVistania6,
  idilioVistania7,
  idilioVistania8,
  idilioVistania9,
  idilioVistania10,
  idilioVistania11,
  idilioVistania12,
];

const widths = [
  540, // FAC1 (1332x1788)
  540, // FAC2 (1332x1788)
  540, // FAC3 (1332x1788)

  1400, // LOB1 (1920x903)

  1400, // SAL1 (1920x727)
  1200, // SAL2 (1920x866)
  1500, // SAL3 (2560x513)

  1200, // HAB1 (1920x881)
  1200, // HAB2 (1920x633)
  1400, // HAB3 (1920x1290)

  1400, // BAN1 (1920x2472)
  1200, // BAN2 (1920x1367)
];

const styles = {
  fadeInRightBig: {
    animation: "x 1s",
    animationName: Radium.keyframes(fadeInRightBig, "fadeInRightBig"),
  },
};

const Gallery = () => {
  const [itemsGallery, setItemsGallery] = useState<
    { img: string; width: string }[]
  >([]);
  const [itemsModal, setItemsModal] = useState<
    { source: string; id: number }[]
  >([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const isTablet = useMediaQuery({ query: "(max-width: 1224px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 600px)" });

  useEffect(() => {
    const ratio = isMobile ? 0.27 : isTablet ? 0.55 : 0.69;
    const gallery = imagesIdilioVistania.map((v, index) => {
      return {
        img: v,
        width: `${Math.floor(widths[index] * ratio)}px`,
      };
    });

    const modal = imagesIdilioVistania.map((v, index) => {
      return {
        source: v,
        id: index,
      };
    });

    setItemsGallery(gallery);
    setItemsModal(modal);
  }, []);

  const settings = {
    className: "slider variable-width",
    centerMode: itemsGallery.length > 1 ? true : false,
    infinite: true,
    centerPadding: itemsGallery.length > 1 ? "40px" : "",
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1500,
    variableWidth: true,

    prevArrow: (
      <button>
        <FontAwesomeIcon icon={faCaretLeft} />
      </button>
    ),
    nextArrow: (
      <button>
        <FontAwesomeIcon icon={faCaretRight} />
      </button>
    ),
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          centerPadding: itemsGallery.length > 1 ? "0px" : "",
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerPadding: itemsGallery.length > 1 ? "0px" : "",
        },
      },
    ],
  };

  return (
    <StyleRoot>
      <div className="cont-about">
        <div className="cont-gallery" style={styles.fadeInRightBig}>
          {itemsGallery.length > 0 && (
            <Slider key={itemsGallery.length} {...settings}>
              {itemsGallery.map(({ img, width }, index) => (
                <div
                  className="item"
                  key={index}
                  style={{ width: width }}
                  onClick={() => {
                    setCurrentIndex(index);
                    setModalIsOpen(true);
                  }}
                >
                  <div className="cont-img-slide">
                    <Img
                      src={img}
                      alt=""
                      loader={
                        <div className="loader-image">
                          <FontAwesomeIcon icon={faSpinner} pulse />
                        </div>
                      }
                      loading="lazy"
                    />
                  </div>
                </div>
              ))}
            </Slider>
          )}
          <ModalGateway>
            {modalIsOpen ? (
              <Modal
                onClose={() => setModalIsOpen(false)}
                styles={{
                  blanket: (base: any) => ({
                    ...base,

                    display: "flex",

                    alignItems: "center",

                    justifyContent: "center",
                  }),

                  positioner: (base: any) => ({
                    ...base,

                    inset: 0,

                    display: "flex",

                    alignItems: "center",

                    justifyContent: "center",
                  }),

                  dialog: (base: any) => ({
                    ...base,

                    maxWidth: "95vw",

                    maxHeight: "95vh",

                    margin: "auto",
                  }),
                }}
              >
                <Carousel
                  views={itemsModal}
                  currentIndex={currentIndex}
                  styles={{
                    container: (base: any) => ({
                      ...base,
                      height: "auto",
                      minHeight: "100vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }),

                    view: (base: any) => ({
                      ...base,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "auto",
                      minHeight: "100vh",
                    }),

                    navigation: (base: any) => ({
                      ...base,
                      alignItems: "center",
                    }),
                  }}
                />
              </Modal>
            ) : null}
          </ModalGateway>
        </div>
      </div>
    </StyleRoot>
  );
};

export default Gallery;
